(function ($) {

    //Dependent dropdowns function
    Drupal.behaviors.UGCostFilters = {
        attach: function (context, settings) {
            var dependentMealPlanDropdowns = function () {
                if ($("#residence button").attr('title') === 'Yes') {
                    $("#meal-plan select option[value='No']").attr('disabled', 'disabled');
                    $('#meal-plan select').selectpicker('val', ['Yes']);
                }
                else {
                  $("#meal-plan select option[value='No']").removeAttr('disabled');
                  $('#meal-plan select').selectpicker('val', ['No']);
                }

                // Refresh dropdowns
                // $('.selectpicker').selectpicker('refresh');

                // @todo: Bootstrap Select v1.14.0-beta3 has a bug preventing refresh
                // https://github.com/snapappointments/bootstrap-select/issues/2738
                $('#meal-plan select').selectpicker('destroy');
                $('#meal-plan select').selectpicker({
                  width: '100%',
                  dropupAuto: false
                });
            };

            // On page load or refresh
            dependentMealPlanDropdowns();
            // Select list changes
            $("#residence select").change(
                function () {
                    $("#meal-plan select option").prop('disabled', false);
                    dependentMealPlanDropdowns();
                }
            );
        }
    };
})(jQuery);

